// extracted by mini-css-extract-plugin
export default {"container":"banner-overview-component_container__F+8NR","truncate-table":"banner-overview-component_truncate-table__Ld0CO","table-text-faded":"banner-overview-component_table-text-faded__gpD5p","isDeleted":"banner-overview-component_isDeleted__PdMJi","legend":"banner-overview-component_legend__wMc6z","legendItem":"banner-overview-component_legendItem__5VHKE","text":"banner-overview-component_text__mvRNe"};
    if(module.hot) {
      // 1792500651389
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  